enum DefaultActivityTypeName {
  CALL = "Call",
  EMAIL = "Email",
  LUNCH = "Lunch",
  MEETING = "Meeting",
  TASK = "Task",
  TEXT = "Text",
  VISIT = "Visit",
}

export default DefaultActivityTypeName;
